<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    .lang-switcher {
        position: relative;
        float: right;
        margin-right: 40px;
        margin-top: 27px;
    }

    .lang-switcher-item {
        font-family: 'Raleway', sans-serif;
        font-size: 1.125rem;
        color: $secondary-color;
        cursor: pointer;
        transition: color .3s;
        outline: none;

        &.is-active {
            color: $primary-color;
            font-weight: bold;
        }

        &:hover, &:focus {
            color: $primary-color;
        }
    }

    div#lang-switcher-view {
        position: relative;
        float: right;
        margin-right: 10px;
        margin-top: 21px;
        border-radius: 4px;
        border: 1px solid #E3E7EF;

        span.switch-button {
            cursor: pointer;
            display: inline-block;
            padding: 5px 20px;
            background-color: white;
            font-family: 'Raleway', sans-serif;
            text-align: center;
            font-weight: bold;

            &.first-span {
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;

                &.active {
                    color: white;
                    background-color: $secondary-color;
                }
            }

            &.second-span {
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;

                &.active {
                    color: white;
                    background-color: $secondary-color;
                }
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#lang-switcher-view {
            span.switch-button {
                padding: 5px 10px;
            }
        }
    }
</style>

<template>
    <div id="lang-switcher-view">
        <span class="first-span switch-button" :class="{ 'active': $i18n.locale === 'cs' }" v-on:click="changeLang('cs')">CZ</span><span class="second-span switch-button" :class="{ 'active': $i18n.locale === 'en' }" v-on:click="changeLang('en')">EN</span>
    </div>

    <!--
    <div class="lang-switcher">
        <button
                class="lang-switcher-item"
                :class="{ 'is-active': $i18n.locale === 'cs' }"
                @click="() => changeLang('cs')"
        >CZ</button>
        |
        <button
                class="lang-switcher-item"
                :class="{ 'is-active': $i18n.locale === 'en' }"
                @click="() => changeLang('en')"
        >EN</button>
    </div>
    -->
</template>

<script>
    import Vue from 'vue'
    import VueCookies from 'vue-cookies'
    Vue.use(VueCookies)

    export default {
        methods: {
            changeLang (lang) {
                localStorage.setItem('lang', lang)
                this.$cookies.set('lang', lang, 60 * 60 * 24 * 30);
                window.location.reload();
                //this.$router.go();
                //location.replace('/')
            }
        }
    }
</script>
